// extracted by mini-css-extract-plugin
module.exports = {"personalIncomeInput":"basic_personalIncomeInput__jkniQ","personalIncomeInfo":"basic_personalIncomeInfo__IuLD7","featuresSlide":"basic_featuresSlide__ALz22"};